import { Component, inject, OnInit } from '@angular/core';
import { VariablesService } from 'src/app/shared/services';

@Component({
  standalone: true,
  imports: [],
  selector: 'app-mini-footer',
  templateUrl: './mini-footer.component.html',
  styleUrls: ['./mini-footer.component.scss']
})
export class MiniFooterComponent {
  public vars: VariablesService = inject(VariablesService);
  currentYear = new Date().getFullYear();
}
